import { __awaiter } from "tslib";
import * as _ from "lodash";
import { Utilities } from "../../shared/utilities";
export const getNotificationMessages = (dispatch, notificationStorageKey) => __awaiter(void 0, void 0, void 0, function* () {
    const updateViewedStatusFromLocalStorage = (messages) => {
        if (typeof (Storage) !== "undefined") {
            const localStoreMessages = JSON.parse(localStorage.getItem(notificationStorageKey)) || [];
            const updatedMessages = (messages || []).map((msg) => {
                const localMessage = localStoreMessages.find((lmsg) => lmsg.id === msg.id);
                if (localMessage != null) {
                    msg.viewed = localMessage.viewed;
                }
                return msg;
            });
            return updatedMessages;
        }
    };
    const fetchPackages = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield Utilities.getFetch("api/navigation/notification");
            const messages = updateViewedStatusFromLocalStorage(res) || [];
            dispatch({ type: "SET_NOTIFICATION_MESSAGES", notificationMessages: messages });
        }
        catch (e) {
            console.error("Unable to retrive notification message: " + e);
        }
    });
    fetchPackages();
});
export const getLastReadNotification = (dispatch, releaseNoteStorageKey) => {
    const fnn = JSON.parse(localStorage.getItem(releaseNoteStorageKey));
    if (!_.isEmpty(fnn)) {
        dispatch({ type: "SET_LAST_READ_VERSION", lastReadVersion: fnn.lastReadVersion });
    }
    else {
        setLastReadVersion(dispatch, null, releaseNoteStorageKey);
    }
};
export const setLastReadVersion = (dispatch, lastReadVersion, releaseNoteStorageKey) => __awaiter(void 0, void 0, void 0, function* () {
    localStorage.setItem(releaseNoteStorageKey, JSON.stringify({
        lastReadVersion: lastReadVersion
    }));
    dispatch({ type: "SET_LAST_READ_VERSION", lastReadVersion: lastReadVersion });
});
